<template>
  <div>
    <table-layout title="تنظیمات">
      <template #buttons>
        <router-link :to="{ name: 'CreateSiteInfo' }">
          <b-button pill variant="purple" class="ml-1 mb-1"> تنظیمات جدید</b-button>
        </router-link>
      </template>

      <template #table>
        <b-table v-bind="tableAttributes" :fields="fields" :items="siteInfos">
          <template #cell(name)="data">
            {{ nameFa(data.item) }}
          </template>

          <template #cell(value)="data">
            <b-img v-if="data.item.name === 'icon'|| data.item.name === 'loadingIcon'"
                   :src="data.item.value"
                   thumbnail
                   fluid
                   center
                   alt=""/>
            <span v-else-if="data.item.name === 'free_city_delivery'">
              {{ data.item.value.province.name }}-{{ data.item.value.name }}
            </span>
            <span v-else-if="data.item.name === 'default_province'">
              {{ data.item.value.name }}
            </span>
            <span v-else-if="data.item.name === 'default_city'">
               {{ data.item.value.province.name }}-{{ data.item.value.name }}
            </span>
            <span v-else-if="data.item.name === 'dashboardVerificationAccess'">
              {{ dashboardVerificationAccess[data.item.value] }}
            </span>
            <span v-else-if="data.item.name === 'orderVerificationAccess'">
              {{ orderVerificationAccess[data.item.value] }}
            </span>
            <span v-else-if="data.item.name === 'cartType'">
              {{ cartType[data.item.value] }}
            </span>
            <span v-else-if="data.item.name === 'registerType'">
              {{ registerType[data.item.value] }}
            </span>
            <span v-else-if="data.item.name === 'gate_status'">
              {{ gateStatus[data.item.value] }}
            </span>
            <span v-else-if="data.item.name === 'order_on_unauthenticated_shopping_cart'">
              {{ OrderOnUnAuthenticatedShoppingCart[data.item.value] }}
            </span>
            <span v-else-if="data.item.name === 'login_options'">
              {{ LoginOptions[data.item.value] }}
            </span>
            <span v-else-if="data.item.name === 'delivery_option'">
              {{ DeliveryOptions[data.item.value] }}
            </span>
            <span v-else-if="data.item.name === 'loan_options'">
              {{ LoanOptions[data.item.value] }}
            </span>
            <span v-else-if="data.item.name === 'rescue_mode'">
              {{ RescueOption[data.item.value] }}
            </span>
            <span v-else-if="data.item.name === 'chat_activity'">
              {{ ChatActivityOptions[data.item.value] }}
            </span>
            <span v-else-if="data.item.name === 'cash_on_delivery_categories'">
              {{ data.item.value.name }}
            </span>
            <span v-else-if="data.item.name === 'chat_access'">
              {{ ChatAccessOptions[data.item.value] }}
            </span>
            <span v-else-if="data.item.name === 'default_language'">
              {{ data.item.value.name }}
            </span>
            <span v-else-if="data.item.name === 'profile_fill_requirement'">
              {{ ProfileFillRequirementOptions[data.item.value] }}
            </span>
            <span v-else-if="data.item.name === 'send_sms_after_two_step_login'">
              {{ sendSmsAfterTwoStepLogin[data.item.value] }}
            </span>
            <span v-else-if="data.item.name === 'show_users_orders_in_main_dashboard'">
              {{ showUsersOrdersInMainDashboard[data.item.value] }}
            </span>
            <span v-else-if="data.item.name === 'show_pre_factor'">
              {{ showPreFactorOptions[data.item.value] }}
            </span>
            <span v-else-if="data.item.name === 'sms_panel_settings'">
              {{ smsPanelSettingsSummary(data.item.value) }}
            </span>
            <span v-else>
              {{ data.item.value }}
            </span>
          </template>

          <template #cell(action)="data">
            <span
                class="h5"
                v-if="isDeletable(data.item)"
                @click="deleteFunction(data.item)"
                v-b-tooltip.hover
                title="حذف"
            >
              <b-icon icon="trash"></b-icon>
            </span>

            <span class="h5" v-b-tooltip.hover title="ویرایش">
              <router-link
                  :to="{
                  name: 'UpdateSiteInfo', 
                  params: { id: data.item.id } 
                }"
              >
                <b-icon icon="pencil" class="mr-3"></b-icon>
              </router-link>
            </span>
          </template>
        </b-table>
      </template>

    </table-layout>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import TableLayout from '../../components/dashboard/TableLayout'
import Pagination from "../../components/dashboard/Pagination";
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {
  dashboardVerificationAccess,
  orderVerificationAccess,
  cartType,
  registerType,
} from "../../components/dashboard/SiteInfoVerificationOptions";
import {gateStatus,} from "../../components/dashboard/GateStatus";
import {OrderOnUnAuthenticatedShoppingCart} from '../../components/dashboard/OrderOnUnAuthenticatedShoppingCart';
import {DeliveryOptions} from '../../components/dashboard/DeliveryOptions';
import {LoginOptions} from "../../components/dashboard/LoginOptions";
import {LoanOptions} from "../../components/dashboard/LoanOptions";
import {RescueOption} from "../../components/dashboard/RescueOption";
import {ChatAccessOptions} from "../../components/dashboard/ChatAccess";
import {ChatActivityOptions} from "../../components/dashboard/ChatActivity";
import {ProfileFillRequirementOptions} from "../../components/dashboard/profileFillRequirementOptions";
import {sendSmsAfterTwoStepLogin} from "../../components/dashboard/sendSmsAfterTwoStepLogin";
import {showUsersOrdersInMainDashboard} from "../../components/dashboard/showUsersOrdersInMainDashboard";
import {showPreFactorOptions} from "../../components/dashboard/showPreFactorOptions";

export default {
  name: "SiteInfo",
  components: {TableLayout, Pagination},
  data() {
    return {
      fields: [
        {key: "name", label: "نام"},
        {key: "value", label: "مقدار"},
        {key: "action", label: "عملیات"},
      ],
      tableAttributes,
      dashboardVerificationAccess,
      orderVerificationAccess,
      cartType,
      registerType,
      gateStatus,
      OrderOnUnAuthenticatedShoppingCart,
      DeliveryOptions,
      LoginOptions,
      LoanOptions,
      RescueOption,
      ChatAccessOptions,
      ChatActivityOptions,
      ProfileFillRequirementOptions,
      sendSmsAfterTwoStepLogin,
      showUsersOrdersInMainDashboard,
      showPreFactorOptions,
    }
  },
  computed: {
    ...mapGetters({
      siteInfos: "SiteInfo/getSiteInfos",
      attributes: "SiteInfo/getAttributes",
    }),
  },
  methods: {
    ...mapActions({
      deleteSiteInfo: "SiteInfo/deleteSiteInfo",
    }),
    deleteFunction(item) {
      if (confirm('آیا از حذف این تنظیمات اطمینان دارید؟')) {
        this.deleteSiteInfo(item);
      }
    },
    nameFa(item) {
      for (const [key, att] of Object.entries(this.attributes)) {
        if (key == item.name)
          return att.fa
      }

      return item.name
    },
    isDeletable(item) {
      for (const [key, att] of Object.entries(this.attributes)) {
        if (key == item.name)
          return att.delete
      }

      return false
    },
    smsPanelSettingsSummary(value) {
      let settings = value
      if (typeof value === 'string') {
        try {
          settings = JSON.parse(value)
        } catch (e) {
          return value
        }
      }

      if (!settings || typeof settings !== 'object') {
        return '-'
      }

      const templatesCount = settings.templates
          ? Object.keys(settings.templates).length
          : 0

      return `API تنظیم شده | ${templatesCount} قالب`
    }
  },
  mounted() {
    this.$store.dispatch("SiteInfo/getSiteInfos");
  },
};
</script>